"use strict";

import {EventEmitter} from 'fbemitter';
import $ from 'jquery';

import { AccountChangeType } from '../endpoints/AccountChangeRequestService';
import { securityCode } from '../common/validators';
import { showValidationMessageForElement } from '../common/Utils';

const FORM_SELECTOR = '#account-settings-form';


/**
 * Shows wizard navigation steps that are only present for profile accounts
 * Also shows the disabled links for Schools, Sports, and payment
 */
function cleanUpSteps(wizard, changeRequest){

    if (changeRequest.changeRequestType === AccountChangeType.CREATE_ACCOUNT){
        //show the side nav links for the account pages that will be
        //filled out after they create their account
        $('#sidebar li.hidden').removeClass('hidden');
    }

    if (changeRequest.changeRequestType === AccountChangeType.CREATE_PROFILE_ACCOUNT){
        //show the sports wizard step
        $('.wizard-steps a.disabled').removeClass('disabled')
            .closest('li').removeClass('hidden');
    }

    wizard.reloadSteps();
}

export default  {
    wireup : function (){

        securityCode.addMethod();

        let theForm = $(FORM_SELECTOR);
        theForm.validate({
            rules: {
                'edit-password-confirm' : {
                    'equalTo': '#edit-password'
                }
            },
            messages : {
                'edit-password-confirm' : {
                    'equalTo': 'passwords must match'
                }
            }
        });

        // trigger the validation message for edit-password to always display the password requirement
        showValidationMessageForElement(FORM_SELECTOR, 'edit-password', 'passwordNCAA');
    },
    validate : function (wizard){

        let theForm = $(FORM_SELECTOR);
        let isValid = theForm.valid();
        let changeRequest = theForm.data('change-request');

        if (isValid === true){
            cleanUpSteps(wizard, changeRequest);
        }

        return new Promise(function(resolve){
            resolve(isValid);
        });
    }
};


// WEBPACK FOOTER //
// /mnt/appdata/jenkins/jobs/EC_Registration/workspace/web/app/~/eslint-loader!./js/register/AccountSettingsSection.js